import client from '../utils/client';
import { adminsUrl, operatorsUrl, profileUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";
import { unwrapList } from '../utils/apiList';

const cookies = new Cookies();

export const adminService = {
  adminsList,
  addAdmin,
  getAdmin,
  updateAdmin,
  operatorsList,
  getProfile,
  updateProfile,
};

function adminsList({ pageID, perPage, searchInput = '', role = 'all', orderBy = 'created_at', orderType = 'desc' }) {
  const params = new URLSearchParams();
  params.set('page', pageID);
  params.set('per_page', perPage);
  if (searchInput) {
    params.set('s', searchInput);
  }
  if (role) {
    params.set('role', role);
  }
  if (orderBy) {
    params.set('order_by', orderBy);
  }
  if (orderType) {
    params.set('order_type', orderType);
  }
  return client.get(adminsUrl + '?' + params.toString())
    .then((response) => response)
    .catch(handleResponse);
}

function addAdmin(formData) {
  return client.post(adminsUrl + '/create', formData)
    .then((response) => response)
    .catch(handleResponse);
}

function getAdmin(adminID) {
  return client.get(adminsUrl + '/' + adminID + '/show')
    .then((response) => response)
    .catch(handleResponse);
}

function updateAdmin(formData) {
  return client.post(adminsUrl + '/update', formData)
    .then((response) => response)
    .catch(handleResponse);
}

function operatorsList() {
  return client.get(operatorsUrl)
    .then((response) => unwrapList(response.data && response.data.body && response.data.body.operators))
    .catch(handleResponse);
}

function getProfile() {
  return client.get(profileUrl)
    .then((response) => response)
    .catch(handleResponse);
}

function updateProfile(formData) {
  return client.post(profileUrl + '/update', formData)
    .then((response) => response)
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response;
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}
